<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils :key="entity.id" :title="entity.id > 0 ? `${entity.name}` : 'Criar Clientes'"/>
            <breadcrumb
                    :items="[{label: 'Pesquisa de Clientes', path: '/customers'}, {label: entity.id > 0 ? `${entity.name}` : 'Criar Cliente', path: $router.currentRoute.path}]"/>

            <form @submit.prevent.stop="submit" novalidate>
                <ibox type="tab_right">
                    <template v-slot:title>
                        <h5 v-if="!$appUtils.isMobile()"><svg-icon icon="user-tie"/></h5>
                    </template>

                    <template v-slot:tabs>
                        <Tabs :tabs="tabs" @onTabSelected="onTabSelected"/>
                    </template>

                    <template v-slot:content>
                        <transition name="tab" mode="out-in">
                            <GeneralTab :entity="entity"
                                        :errors="errors"
                                        key="general"
                                        v-if="currentTab === 0"/>
                            <FinancialMovementsTab v-else-if="currentTab === 1"
                                                   :entity="entity"
                                                   key="fin"/>
                            <ContactsTab :entity="entity"
                                         v-else-if="currentTab === 2"
                                         key="contact"
                                         @onUpdateTabBadges="updateTabBadges"/>
                            <ProductsTab :entity="entity"
                                         v-else-if="currentTab === 3"
                                         key="prod"
                                         @onUpdateTabBadges="updateTabBadges"/>
                            <AccountsTab :entity="entity"
                                         v-else-if="currentTab === 4"
                                         key="account"
                                         @onUpdateTabBadges="updateTabBadges"/>
                            <ProposalsTab :entity="entity"
                                          key="proposals"
                                          v-else-if="currentTab === 5"/>
                            <FilesTab :entity="entity" key="files" v-else/>
                        </transition>
                    </template>
                    <template v-slot:footer>
                        <div class="container-fluid-grid">
                            <div class="row">
                                <div class="col t-r">
                                    <span class="btn-group btn-group-sm" role="group">
                                        <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon icon="sync"/> Limpar</button>
                                        <router-link to="/customers" class="btn btn-dark btn-sm"><svg-icon icon="search"/> Pesquisar</router-link>
                                        <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="save"/> Salvar</button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>
                </ibox>
            </form>
        </template>
    </DefaultTmpl>
</template>

<script>
    import CRUDEdit from '@/mixins/CRUDEdit'
    import ContactsTab from "./ContactsTab"
    import GeneralTab from "./GeneralTab"
    import ProductsTab from "./ProductsTab"
    import AccountsTab from "./AccountsTab"
    import FilesTab from "./FilesTab"
    import ProposalsTab from "./ProposalsTab"
    import Tabs from '@/components/particles/Tabs'
    import FinancialMovementsTab from "./FinancialMovementsTab";

    export default {
        name: "CustomersEdit",
        components: {
            FinancialMovementsTab,
            Tabs, GeneralTab, ContactsTab, ProductsTab, AccountsTab, FilesTab, ProposalsTab},
        mixins: [
            CRUDEdit.mount('customers')
        ],
        data() {
            return {
                tabs: [{
                    icon: 'info-circle',
                    label: 'Dados do Cliente',
                    active: true
                }, {
                    icon: 'cash-register',
                    label: 'Financeiro',
                    active: false
                }, {
                    icon: 'users',
                    label: 'Contatos',
                    active: false
                }, {
                    icon: 'wheat',
                    label: 'Produtos',
                    active: false
                }, {
                    icon: 'university',
                    label: 'Contas',
                    active: false
                }, {
                    icon: 'handshake',
                    label: 'Propostas',
                    active: false
                }, {
                    icon: 'file',
                    label: 'Arquivos',
                    active: false
                }],
                currentTab: 0,
                errors: {}
            }
        },
        methods: {
            onTabSelected(tab) {
                this.currentTab = tab.index;
            },
            createEntity() {
                const mold = {
                    id: null,
                    name: null,
                    commercial_name: null,
                    inscricao_estadual:null,
                    inscricao_municipal:null,
                    city_id: null,
                    city_name: null,
                    disable_reason: null,
                    is_active: true,
                    is_foreign: false,
                    postal_code: null,
                    document:null,
                    neighborhood:null,
                    address:null,
                    address_number:null,
                    address_notes:null,
                    url_site:null,
                    customer_group_id: null,
                    notes: null,
                    customer_contacts_attributes: [],
                    product_descriptions_attributes: [],
                    customer_accounts_attributes: [],
                };

                this.entity = {};
                const outer = this;
                Object.keys(mold).forEach(k => outer.$set(outer.entity, k, mold[k]));
            },
            onLoadSuccess(entity) {
                this.$set(this.entity, 'group_name', entity.customer_group.name);
                this.$set(this.entity, 'city_name', `${entity.city.name}/${entity.city.state.acronym}`);

                const outer = this;
                Object.keys(entity).forEach(k => {
                    let val;

                    if (/(document)$/.test(k) && !entity.is_foreign) val = outer.$appUtils.formatDocument(entity[k]);
                    else if (/(postal_code)$/.test(k) && !entity.is_foreign) val = outer.$appUtils.formatPostalCode(entity[k]);
                    else val = entity[k];

                    outer.$set(outer.entity, k, val);
                });

                this.updateTabBadges();
            },
            updateTabBadges() {
                const fin_count = this.entity.financial_movements_count;
                const contacts = this.entity.customer_contacts_attributes;
                const prods = this.entity.product_descriptions_attributes;
                const accounts = this.entity.customer_accounts_attributes;

                this.$set(this.tabs, 2, {...this.tabs[2], badge: (contacts && contacts.length > 0) ? contacts.length : null});
                this.$set(this.tabs, 3, {...this.tabs[3], badge: (prods && prods.length > 0) ? prods.length : null});
                this.$set(this.tabs, 4, {...this.tabs[4], badge: (accounts && accounts.length > 0) ? accounts.length : null});

                if (fin_count > 0)
                    this.$set(this.tabs, 1, {...this.tabs[1], badge: this.$appUtils.humanizeNumber(fin_count, 1)});

                if (this.entity.proposals_count > 0)
                    this.$set(this.tabs, 5, {...this.tabs[5], badge: this.$appUtils.humanizeNumber(this.entity.proposals_count, 1)});

                if (this.entity.group_files_count > 0)
                    this.$set(this.tabs, 6, {...this.tabs[6], badge: this.$appUtils.humanizeNumber(this.entity.group_files_count, 1)});
            }
        }
    }
</script>
